import { isEmpty } from 'lodash';

/**
 * Checks if access is granted for a given pathname based on a list of permissions.
 *
 * @param {Object} params - The parameters for the function.
 * @param {string} params.pathname - The pathname to check access for.
 * @param {Object} params.permissionList - The list of permissions to validate against.
 * @returns {boolean} - Returns true if access is granted, false otherwise.
 */

const checkIsAccessGranted = ({ pathname, permissionList }) => {
  if (pathname === '/' || isEmpty(permissionList)) return true;
  const accessOnly = Object.values(permissionList).flat();
  const accessList = accessOnly?.filter((route) => pathname.includes(route?.path) && route?.permission?.isCanRead);
  return accessList?.length > 0;
};

export default checkIsAccessGranted;
